<div class="w-full flex justify-start items-center p-4">
    <i class="ico-Close cursor-pointer text-xl ml-3" (click)="dialogRef.close()"></i>
    <h3 class="text-lg">تاریخ اقامت</h3>
</div>
<div class="w-full p-4">
    <p class="text-black-300 text-sm mb-4">رزرو تنها از طریق تاریخ‌های زیر امکان‌پذیر است.</p>
    <ul class="flex flex-wrap ">
       
        <li class="border border-solid rounded-full flex justify-center items-center min-h-[40px] mb-2 ml-2 cursor-pointer min-w-[70px] {{item.selected ? 'bg-blue-500 text-white' : 'text-gray-600'}}"
            (click)="selectedNights(item.night)" *ngFor="let item of filterPackages;let index = index">
            <span class="text-sm  "> {{item.night == 0 ? 'همه' : item.night + ' شب ' }} </span>
        </li>
    </ul>
</div>
<div class="w-full min-h-[330px] overflow-y-auto  ">
    <div class="flex justify-between p-4 flex-wrap items-center w-full">
        <div class="border border-solid rounded-lg mb-3 p-3 text-center w-[400px] h-[60px] relative"
         *ngFor="let item of packages;let index = index">
         <mat-radio-group [(ngModel)]="selectedPackageVal">
            <mat-radio-button [value]="item.id" color="primary"  (click)="selectPackage(item)">
                <div class="flex items-center justify-between">
                    <span class="text-xs">ورود:</span>
                    <span class="text-sm font-bold mx-2">{{item.startDatePersian}}</span>
                    <span class="text-xs bg-gray-200 p-2 text-gray-500 rounded-lg">{{item.night}}&nbsp;شب</span>
                    <span class="text-xs mx-2">خروج:</span>
                    <span class="text-sm font-bold">{{item.endDatePersian}}</span>
                </div>
    
            </mat-radio-button>
            </mat-radio-group>
        </div>
        
    </div>
</div>
<div class="w-full p-4">
    <button (click)="setSearch()" [disabled]="!isSend" mat-flat-button color="primary" class="!h-11 w-[140px] !text-base font-semi-bold ml-2">
        اعمال تاریخ
    </button>
    <button (click)="dialogRef.close()"  class="!border-2 !h-11 !border-solid !border-blue-500 w-[140px]" mat-button color="primary">
        بستن
    </button>
</div>